import InformationApp from './app'

export default InformationApp
